import { render, staticRenderFns } from "./editorder-component.vue?vue&type=template&id=477daee5"
import script from "./editorder-component.vue?vue&type=script&lang=ts"
export * from "./editorder-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports